import { defineStore } from 'pinia';
import Config from '@/Config';

export const usePageSectionsStore = defineStore('pageSections', {
    state: () => ({
        pageSections: [],
    }),
    actions: {
        addPageSection({ section, parentSection }) {
            if (parentSection) {
                parentSection.sections.push(section);
            }
            else {
                const updatedSections = [...this.pageSections];
                updatedSections.push(section);
                this.pageSections = updatedSections;
            }
        },
    },
    getters: {
        hasRewardsSection: state => state.pageSections.some(i => i.urlName === 'rewards'),
        rewardSectionUrl() {
            if (this.hasRewardsSection) {
                return '#/section/rewards';
            }

            return Config.projectNavigation.backProjectUrl;
        },
    },
});